import { render, staticRenderFns } from "./LocationCustomFields.vue?vue&type=template&id=664a0722&scoped=true"
import script from "./LocationCustomFields.vue?vue&type=script&lang=ts"
export * from "./LocationCustomFields.vue?vue&type=script&lang=ts"
import style0 from "./LocationCustomFields.vue?vue&type=style&index=0&id=664a0722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a0722",
  null
  
)

export default component.exports